<template>
    <Breadcrumbs main="Bonus Ui" title="Rating" />
    <div class="container-fluid">
        <div class="row">
            <clickableValue />
            <movieRating />
            <heartRating />
            <starRating />
            <disabledRating />
            <animationRating />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const clickableValue = defineAsyncComponent(() => import("@/components/theme/advance/rating/clickableValue.vue"))
const movieRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/movieRating.vue"))
const heartRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/heartRating.vue"))
const starRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/starRating.vue"))
const disabledRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/disabledRating.vue"))
const animationRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/animationRating.vue"))
</script>